let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kKXTS")).then(() => parcelRequire('6pgwb'));